<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-input placeholder="用户名" class="a_input_self margin_self" v-model="queryParam.operName" />
			<a-input placeholder="模块" class="a_input_self margin_self" v-model="queryParam.title" />
			<a-select placeholder="操作类型" class="a_input_self margin_self" v-model="queryParam.businessType" default-value="0">
				<a-select-option :value="''">全部</a-select-option>
				<a-select-option v-for="(b, index) in businessTypes" :key="index" :value="b.dictValue">{{
          b.dictLabel
        }}</a-select-option>
			</a-select>
			<a-select placeholder="状态" class="a_input_self margin_self" v-model="queryParam.status" default-value="0">
				<a-select-option :value="''">全部</a-select-option>
				<a-select-option :value="0">成功</a-select-option>
				<a-select-option :value="1">失败</a-select-option>
			</a-select>
			<a-range-picker v-model="range" class="margin_self" :placeholder="['操作开始日期', '操作结束日期']" />
			<a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
			<a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
			<!-- <a-popconfirm v-has="'monitor:operlog:remove'" title="确认清空吗？" @confirm="clean">
				<a-icon slot="icon" type="question-circle-o" style="color: red" />
				<a-button type="danger" ghost icon="close">清空</a-button>
			</a-popconfirm> -->
			<!-- <a-button type="primary" icon="export" @click="exportExcel()">导出</a-button> -->
			<!-- <a-dropdown v-has="'monitor:operlog:remove'" v-if="selectedRowKeys.length > 0">
				<a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
			</a-dropdown> -->
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<s-table size="default" ref="table" rowKey="operId" :columns="columns" :data="loadData" :rangPicker="range"
			 defaultSort="operTime" v-if="operTypeMap" :scroll="{ y: scroll_y }">
				<span slot="businessType" slot-scope="text">
					{{ text | operTypeFilter }}
				</span>
				<span slot="status" slot-scope="text">
					{{ text | statusFilter }}
				</span>

				<span slot="action" slot-scope="text, record">
					<a @click="handleDetail(record)">详细</a>
				</span>
			</s-table>
		</div>
		<operLog-modal ref="modal" :operTypeMap="operTypeMap" v-if="operTypeMap" />
	</div>
</template>

<script>
	import {
		STable
	} from '@/components'
	import {
		getOperLogList,
		delOperLog,
		cleanOperLog,
		operLogExport
	} from '@/api/monitor'
	import OperLogModal from './modules/OperLogModal.vue'
	import {
		getDictArray
	} from '@/utils/dict'
	import {
		exportExcel
	} from '@/utils/download'
	const operTypeMap = {}
	export default {
		name: 'TableList',
		components: {
			STable,
			OperLogModal,
		},
		data() {
			return {
				scroll_y: 150,
				visible: false,
				labelCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 5,
					},
				},
				wrapperCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 16,
					},
				},
				form: this.$form.createForm(this),
				mdl: {},
				permissions: [],
				// 高级搜索 展开/关闭
				advanced: false,
				// 查询参数
				queryParam: {},
				// 表头
				columns: [{
						title: '记录编号',
						dataIndex: 'operId',
					},
					{
						title: '用户名',
						dataIndex: 'operName',
					},
					{
						title: '时间',
						dataIndex: 'operTime',
					},
					{
						title: 'IP地址',
						dataIndex: 'operIp',
					},
					{
						title: '地点',
						dataIndex: 'operLocation',
					},
					{
						title: '模块',
						dataIndex: 'title',
					},
					{
						title: '类型',
						dataIndex: 'businessType',
						scopedSlots: {
							customRender: 'businessType',
						},
					},

					{
						title: '状态',
						dataIndex: 'status',
						scopedSlots: {
							customRender: 'status',
						},
					},

					{
						title: '详情',
						width: '150px',
						dataIndex: 'action',
						scopedSlots: {
							customRender: 'action',
						},
					},
				],
				range: null,
				// 加载数据方法 必须为 Promise 对象
				loadData: (parameter) => {
					return getOperLogList(Object.assign(parameter, this.queryParam))
				},
				operTypeMap,
				businessTypes: [],
				selectedRowKeys: [],
				selectedRows: [],
			}
		},
		filters: {
			operTypeFilter(type) {
				return operTypeMap[type].text
			},
			statusFilter(status) {
				const statusMap = {
					1: '失败',
					0: '成功',
				}
				return statusMap[status]
			},
		},
		beforeCreate() {},
		async created() {
			// 字典两种用法，各有优缺点
			// operTypeMap = await getDictMap('sys_oper_type')
			// this.operTypeMap = operTypeMap
			// this.operTypeMap.forEach((value, key, mymap) => {
			//   this.businessTypes.push({ code: key, label: value })
			// })
			this.businessTypes = await getDictArray('sys_oper_type')
			this.businessTypes.map((d) => {
				operTypeMap[d.dictValue] = {
					text: d.dictLabel,
				}
			})
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 50
				}, 1000)
			})
		},
		methods: {
			onSelectChange(selectedRowKeys, selectedRows) {
				this.selectedRowKeys = selectedRowKeys
				this.selectedRows = selectedRows
			},
			handleDetail(record) {
				this.$refs.modal.detail(record)
			},
			handleOk() {
				this.$refs.table.refresh(true)
			},
			exportExcel() {
				exportExcel(operLogExport, this.queryParam)
			},
			delByIds(ids) {
				delOperLog({
					ids: ids.join(',')
				}).then((res) => {
					if (res.code === 200) {
						this.$message.success(`删除成功`)
						this.handleOk()
					} else {
						this.$message.error(res.msg)
					}
					this.selectedRowKeys = []
				})
			},
			// clean () {
			//   cleanOperLog().then(res => {
			//     this.handleOk()
			//   })
			// }
		},
		watch: {
			selectedRows: function(selectedRows) {
				this.needTotalList = this.needTotalList.map((item) => {
					return {
						...item,
						total: selectedRows.reduce((sum, val) => {
							return sum + val[item.dataIndex]
						}, 0),
					}
				})
			},
		},
	}
</script>
